import { useProxyModelValue as f, useResponsive as b } from "@onereach/ui-components-common/hooks";
import { O as y } from "./OrCheckboxTree-D6KuOyBg.mjs";
import { O as g, F as O, a as t } from "./OrFormGroup-C5sateI6.mjs";
import { defineComponent as V, toRef as S, computed as h, resolveComponent as p, openBlock as l, createBlock as i, withCtx as s, renderSlot as k, createElementBlock as C, Fragment as F, renderList as G } from "vue";
import { _ as M } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const v = V({
  name: "OrCheckboxGroup",
  components: {
    OrCheckboxTree: y,
    OrFormGroup: g
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    },
    direction: {
      type: String,
      default: () => O.Vertical
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    spacing: {
      type: String,
      default: t.SM
    }
  },
  setup(e, r) {
    const a = f(S(e, "modelValue"), r.emit), { isMobile: n } = b(), d = h(() => n.value ? t.NONE : e.spacing);
    return {
      proxyModelValue: a,
      localSpacing: d
    };
  }
});
function B(e, r, a, n, d, $) {
  const u = p("OrCheckboxTree"), m = p("OrFormGroup");
  return l(), i(m, {
    label: e.label,
    error: e.error,
    hint: e.hint,
    disabled: e.disabled,
    direction: e.direction,
    spacing: e.localSpacing
  }, {
    addon: s(() => [
      k(e.$slots, "addon")
    ]),
    default: s(() => [
      (l(!0), C(F, null, G(e.options, (o) => (l(), i(u, {
        key: o.value,
        modelValue: e.proxyModelValue,
        "onUpdate:modelValue": r[0] || (r[0] = (c) => e.proxyModelValue = c),
        item: o,
        disabled: e.disabled || o.disabled,
        readonly: e.readonly || o.readonly,
        collapsible: o.collapsible,
        expanded: o.expanded
      }, null, 8, ["modelValue", "item", "disabled", "readonly", "collapsible", "expanded"]))), 128))
    ]),
    _: 3
  }, 8, ["label", "error", "hint", "disabled", "direction", "spacing"]);
}
const R = /* @__PURE__ */ M(v, [["render", B]]);
export {
  R as O
};
//# sourceMappingURL=OrCheckboxGroup-oWfQ8P5a.mjs.map
